import React from 'react';
import styled from 'styled-components';
import {
  ProfileCard,
  CardTitle,
  CardContent,
  IdeologyChart,
  IdeologyAxis,
  IdeologyLabel,
  IdeologyBar,
  IdeologyMarker,
} from './styles';

const AxisValue = styled.span`
  position: absolute;
  top: -18px;
  transform: translateX(-50%);
  font-family: 'JetBrains Mono', 'Consolas', monospace;
  font-size: 0.7rem;
  color: var(--btn-primary);
  letter-spacing: 0.04em;
  white-space: nowrap;
`;

const axes = [
  { left: 'Izquierda', right: 'Derecha', value: 80 },
  { left: 'Progresista', right: 'Conservador', value: 60 },
  { left: 'Estatista', right: 'Libertario', value: 85 },
  { left: 'Globalista', right: 'Nacionalista', value: 80 },
];

const IdeologySection = () => {
  return (
    <ProfileCard>
      <CardTitle>Posicionamiento Ideológico</CardTitle>
      <CardContent>
        <IdeologyChart>
          {axes.map(({ left, right, value }) => (
            <IdeologyAxis key={left}>
              <IdeologyLabel>{left}</IdeologyLabel>
              <IdeologyBar>
                <IdeologyMarker style={{ left: `${value}%` }}>
                  <AxisValue style={{ left: '50%' }}>{value.toFixed(1)}</AxisValue>
                </IdeologyMarker>
              </IdeologyBar>
              <IdeologyLabel>{right}</IdeologyLabel>
            </IdeologyAxis>
          ))}
        </IdeologyChart>
      </CardContent>
    </ProfileCard>
  );
};

export default IdeologySection;
